export const NotFounded = () => {
  return (
    <div>
      <h1>Not Founded</h1>
    </div>
  );
}